import _defineProperty from "@babel/runtime/helpers/defineProperty";
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
import { css } from '@emotion/react';
export var shadowClassNames = {
  RIGHT_SHADOW: 'right-shadow',
  LEFT_SHADOW: 'left-shadow'
};
export var shadowObserverClassNames = {
  SENTINEL_LEFT: 'sentinel-left',
  SENTINEL_RIGHT: 'sentinel-right',
  SHADOW_CONTAINER: 'with-shadow-observer'
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var shadowStyles = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.ProseMirror': _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "& .".concat(shadowClassNames.RIGHT_SHADOW, "::before, .").concat(shadowClassNames.RIGHT_SHADOW, "::after, .").concat(shadowClassNames.LEFT_SHADOW, "::before, .").concat(shadowClassNames.LEFT_SHADOW, "::after"), {
    display: 'none',
    position: 'absolute',
    pointerEvents: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: 2,
    width: 8,
    content: "''",
    height: 'calc(100%)'
  }), "& .".concat(shadowClassNames.RIGHT_SHADOW, ", .").concat(shadowClassNames.LEFT_SHADOW), {
    position: 'relative'
  }), "& .".concat(shadowClassNames.LEFT_SHADOW, "::before"), {
    background: "linear-gradient(to left, transparent 0, ".concat("var(--ds-shadow-overflow-spread, #1E1F2129)", " 140% ), linear-gradient( to right, ", "var(--ds-shadow-overflow-perimeter, transparent)", " 0px, transparent 1px)"),
    top: 0,
    left: 0,
    display: 'block'
  }), "& .".concat(shadowClassNames.RIGHT_SHADOW, "::after"), {
    background: "linear-gradient(to right, transparent 0, ".concat("var(--ds-shadow-overflow-spread, #1E1F2129)", " 140% ), linear-gradient( to left, ", "var(--ds-shadow-overflow-perimeter, transparent)", " 0px, transparent 1px)"),
    right: 0,
    top: 0,
    display: 'block'
  }), "& .".concat(shadowObserverClassNames.SENTINEL_LEFT), {
    height: '100%',
    width: 0,
    minWidth: 0
  }), "& .".concat(shadowObserverClassNames.SENTINEL_RIGHT), {
    height: '100%',
    width: 0,
    minWidth: 0
  })
});